import AppConstants from "../constants/AppConstants";

var MessageUtils = {
  getErrorExpression: function () {
    return this.getExpression(AppConstants.EXPRESSIONS_ERROR);
  },

  getSuccessExpression: function () {
    return this.getExpression(AppConstants.EXPRESSIONS_SUCCESS);
  },

  getExpression: function (expressions) {
    return expressions[Math.floor(Math.random() * expressions.length)];
  },
};

export default MessageUtils;
